import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import i18n, { DEFAULT_LANGUAGE } from 'i18n';

export type Language = 'uz' | 'en' | 'ru';

export interface LanguageStore {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguageStore = create(
  persist<LanguageStore>(
    (set) => ({
      language: DEFAULT_LANGUAGE as Language,

      setLanguage: (language: Language) => {
        set({ language });
        i18n.changeLanguage(language);
      },
    }),
    {
      name: 'examing-language',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
